/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2026-01-27 17:39:37
 */

import React, { useState } from 'react'

import MemberCard from './MemberCard'
import { MEMBER_CONFIG } from '../constants'
import { useAvailableVipKinds } from '../hooks'
import { usePayment } from '../../../app/hooks'
import CONFIG from '../../../constants/config'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

export default function Members({
  handleEventTrack
}: {
  handleEventTrack: (clickItem: string, vipKind?: number) => void
}) {
  const [hoverKind, setHoverKind] = useState<number | null>(null)
  const { defaultSelected } = useAvailableVipKinds()
  const { openVipByKind } = usePayment()
  const activeKind = hoverKind ?? defaultSelected

  const handleBackClick = () => {
    handleEventTrack('back')
    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = '/'
    }
  }

  const handleEnterpriseClick = () => {
    handleEventTrack('点击企业级会员')
    openVipByKind(CONFIG.VIP_KIND.EVIP, 'webVIPSummary')
  }

  return (
    <div className="membersContainer">
      <div className="backButton" onClick={handleBackClick}>
        <LeftOutlined style={{ fontSize: 20, marginRight: 4 }} />
        返回
      </div>
      <div className="title">解锁会员权益，高效协作轻松管理</div>
      <div className="subTitle">{`海量存储空间   更多团队人数   超多水印使用   轻松权限管理`}</div>
      <div className="members">
        {MEMBER_CONFIG.map((member, index) => (
          <MemberCard
            key={index}
            member={member}
            active={activeKind === member.vipKind}
            setHoverKind={setHoverKind}
            handleEventTrack={handleEventTrack}
          />
        ))}
      </div>
      <div className="enterpriseEntry" onClick={handleEnterpriseClick}>
        <span>企业级会员，不限量权益自定义</span>
        <RightOutlined style={{ fontSize: 12, marginLeft: 4 }} />
      </div>
    </div>
  )
}
